import React from 'react';
import Logo from '../ui/Logo';

function AuthLayout({
  leftContent,
  rightContent,
  gradientFrom = 'from-blue-50',
  gradientVia = 'via-sky-50',
  gradientTo = 'to-blue-100',
}) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="absolute top-8 left-6 z-10">
        <Logo />
      </div>
      <div className="flex flex-1">
        <div
          className={`hidden lg:flex lg:w-1/2 m-3 rounded-3xl bg-gradient-to-br ${gradientFrom} ${gradientVia} ${gradientTo} text-gray-800 p-12 flex-col justify-center`}
        >
          <div className="max-w-xl">{leftContent}</div>
        </div>
        <div className="w-full lg:w-1/2 flex items-center justify-center px-4 py-8 md:py-12">
          <div className="w-full max-w-md">
            <div className="lg:hidden text-center mb-6 md:mb-8">
              {leftContent}
            </div>
            <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 sm:p-8 md:p-10 lg:bg-transparent lg:border-0 lg:shadow-none lg:p-8">
              {rightContent}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
